import { APP_ENV } from "@sellernote/shared/src/constants";

import Styled from "./index.styles";

/**
 * 현재 앱의 환경을 표시(경고)하는 뱃지
 */
export default function EnvWarningBadge() {
  return <Styled.container>⚠️ {APP_ENV.toUpperCase()}</Styled.container>;
}
